import React from "react";
import { PropertyInfo } from "../../api/services";
import { Property } from "./components/Property";

interface PropertiesListProps {
  properties?: PropertyInfo[];
}

export const PropertiesList: React.FC<PropertiesListProps> = ({
  properties = [],
}) => {
  return (
    <>
      {properties.map((property) => (
        <Property property={property} key={property.id} />
      ))}
    </>
  );
};
